import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "justify-center items-center flex overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none" }
const _hoisted_3 = { class: "relative w-screen justify-center items-center inline-flex p-200px" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "opacity-75 fixed inset-0 z-40 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
        class: "rounded p-2 bg-black-lp-200 opacity-50 hover:opacity-100 cursor-pointer absolute z-50 top-0 right-0 mt-8 mr-8"
      }, [
        _createVNode(_component_Close, { class: "w-6 text-white" })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          src: _ctx.image,
          alt: ""
        }, null, 8, ["src"])
      ])
    ]),
    _hoisted_4
  ]))
}